import { useLocation } from "react-router";
import { useCallback } from "react";
import { LOCATION_COMPONENTS_SEARCH_PARAMS, LOCATION_NAMES } from "../locationConstants";
import appHistory from "../../../app/appHistory";
import { ValueOf } from "../../../types";

interface useCloseLocationProps {
    locationName: ValueOf<typeof LOCATION_NAMES>;
    typeLocation?: ValueOf<typeof LOCATION_COMPONENTS_SEARCH_PARAMS>;
}

function useCloseLocation({locationName, typeLocation = LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE}: useCloseLocationProps) {
    const { pathname, search } = useLocation();

    return useCallback(() => {
        const searchParams = new URLSearchParams(search);
        // @ts-ignore
        searchParams.delete(typeLocation, locationName);
        appHistory.replace(`${pathname}?${searchParams.toString()}`);
    }, [pathname, search]);
}

export default useCloseLocation;